// @core/api/endpoints/license/get_license_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LicenseStatusResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Get current license status
 * Returns the current license status for the platform including validity, entitlements, grace period state, and compliance information.
 */
export async function GetLicenseStatus(
  params?: {
  },
  options?: RequestOptions
): Promise<LicenseStatusResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/licenses/status`;
  const requestOptions = options;
  return client.get<LicenseStatusResponse>(requestPath, { ...requestOptions, params });
}
